/**
 * SDK / API entity pages under references (classes, methods, typedefs, etc.).
 * Index and SDK roots stay indexable:
 * - references
 * - references.websdk
 * Entity pages get noindex:
 * - references.websdk.Client
 * - references.httpapi.AddUser
 */
export function isSdkMethodPage(fqdn?: string | null): boolean {
  if (!fqdn) return false;

  const parts = fqdn.split('.').filter(Boolean);
  return parts[0] === 'references' && parts.length >= 3;
}
